import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeSession } from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [msg, setMsg] = useState('ESTABLISHING SIGNAL…');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/admin/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Clean the hash before moving on so a refresh doesn't re-run this.
        window.history.replaceState(null, '', window.location.pathname);
        await refresh();
        if (!user.is_admin) {
          setMsg('ACCESS DENIED — NOT AN AUTHORISED BROADCASTER');
          setTimeout(() => navigate('/admin/login', { replace: true, state: { error: 'not_admin' } }), 1500);
          return;
        }
        navigate('/admin', { replace: true, state: { user } });
      } catch (err) {
        console.error(err);
        setMsg('SIGNAL LOST — PLEASE TRY AGAIN');
        setTimeout(() => navigate('/admin/login', { replace: true }), 1500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center font-osd text-[#f5a623]" data-testid="auth-callback">
      <div className="font-display text-3xl mb-4 phosphor-glow">TUNING IN…</div>
      <div className="text-sm tracking-widest text-[#d8b887]">{msg}</div>
      <div className="mt-6 w-40 h-1 bg-[#2a1608] overflow-hidden rounded">
        <div className="h-full bg-[#f5a623] animate-pulse" style={{ width: '60%' }} />
      </div>
    </div>
  );
}
